import { useEffect } from "react";

import { IEventoResponse } from "interfaces/eventos";

import congratulation from "assets/images/illustrations/congratulations.png";
import MDBox from "components/MDBox";
import { CardMedia, Typography } from "@mui/material";
import { Link } from "react-router-dom";

interface Props {
  evento: IEventoResponse;
  updateEvento: () => void;
}
export default function PublicadoSite({ evento, updateEvento }: Props) {
  useEffect(() => {
    updateEvento();
  }, []);

  const urlEventoPublicado = `https://www.tnvteam.com.br/evento/${evento.slug}`;

  return (
    <MDBox>
      <MDBox mb={2}>
        <Typography variant="h3">
          Parabéns! Seu evento foi publicado no site!
        </Typography>
      </MDBox>

      <Typography variant="body2">
        {` O seu evento ${evento.titulo} já está disponível para todos acompanharem.`}
      </Typography>

      <Typography variant="body2">
        Confira os detalhes e compartilhe esse grande momento.
      </Typography>

      <MDBox mt={2} mb={2}>
        <Typography variant="caption">
          <Link to={urlEventoPublicado} target="_blank" rel="noopener">
            <CardMedia
              component="img"
              sx={{ width: 300, m: 0 }}
              image={evento.urlImageDestaque}
              alt="destaque do evento"
            />
            {urlEventoPublicado}
          </Link>
        </Typography>
      </MDBox>
    </MDBox>
  );
}
